import axiosHttp from "services/axiosHttp";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "antd";

export const fetchCashBackUpload = createAsyncThunk("fetchCashBackUpload", async ({ file,channelId }, { rejectWithValue }) => {
	try {
		const formData = new FormData();
		formData.append("file", file);
		const response = await axiosHttp.post(`channel/${channelId}/unitDetails/upload`, formData);
		message.success("Cashback uploaded successfully!");
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || "Something went wrong");
	}
});

const CashBackUploadSlice = createSlice({
	name: "CashBackUploadSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	reducers: {
		resetCashBackUploadSlice: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchCashBackUpload.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});

		builder.addCase(fetchCashBackUpload.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});

		builder.addCase(fetchCashBackUpload.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload || "Unknown error occurred";
		});
	},
});
export default CashBackUploadSlice.reducer;
export const { resetCashBackUploadSlice } = CashBackUploadSlice.actions;
